import { Chip, Typography } from '@mui/material'
import { SxProps } from '@mui/system'
import { FC } from 'react'

import { TradeNegotiationStatus } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'

export type TradeTagProps = {
  status: TradeNegotiationStatus
  sx?: SxProps
}

export const TradeTag: FC<TradeTagProps> = ({ status, sx }) => {
  const { t } = useTranslation('myTrade')
  if (
    status === TradeNegotiationStatus.Completed ||
    status === TradeNegotiationStatus.Error
  )
    return null

  const statusData = {
    [TradeNegotiationStatus.InProgress]: {
      text: t('inProgress'),
      bgcolor: 'primary.main',
    },
    [TradeNegotiationStatus.Dropped]: {
      text: t('dropped'),
      bgcolor: 'grey.100',
    },
    [TradeNegotiationStatus.BrokenOff]: {
      text: t('brokenOff'),
      bgcolor: 'grey.100',
    },
    [TradeNegotiationStatus.Agreed]: {
      text: t('agreed'),
      bgcolor: 'secondary.main',
    },
  }[status]

  return (
    <Chip
      label={
        <Typography variant="subtitle2" color="white">
          {statusData.text}
        </Typography>
      }
      size="small"
      sx={{
        height: 20,
        minWidth: 72,
        bgcolor: statusData.bgcolor,
        borderRadius: '10px',
        ...sx,
      }}
    />
  )
}
